/*
 * Cart upsell carousel navigation.
 *
 * Document-tason click delegation -kuuntelija nuolipainikkeille
 * .cart-upsell -karusellissa. Käyttää natiivia DOM scrollBy:tä, joten
 * ei riippuvuutta mihinkään custom-elementtien lifecycleen.
 *
 * Ladataan erillisenä JS-assettina (ei inline-skriptinä) jotta kuuntelija
 * asennetaan AINA sivunlatauksen yhteydessä — myös silloin kun ostoskori
 * on tyhjä eikä cart-upsell.liquid -snippettiä renderöidä. Inline-skripti
 * snipetin sisällä toimi vain täyden ostoskorin lataussessiossa, koska
 * innerHTML ei aja <script>-tageja section-renderin yhteydessä.
 */

(function () {
  if (window.__cartUpsellNavInstalled) return;
  window.__cartUpsellNavInstalled = true;

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var btn = target.closest('[data-upsell-nav]');
      if (!btn) return;

      var root = btn.closest('.cart-upsell');
      if (!root) return;

      var track = root.querySelector('[data-upsell-track]');
      if (!track) return;

      var firstSlide = track.querySelector('.cart-upsell__slide');
      var slideWidth = firstSlide ? firstSlide.getBoundingClientRect().width : track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = slideWidth + gap;

      track.scrollBy({
        left: btn.getAttribute('data-upsell-nav') === 'next' ? step : -step,
        behavior: 'smooth',
      });
    },
    { passive: true }
  );
})();
